import { render } from "./ProjectSummaryGiftCards.vue?vue&type=template&id=532da1d9"
import script from "./ProjectSummaryGiftCards.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryGiftCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__